import styled from 'styled-components';

export const VESTING_ALLOCATION_COLORS = {
	timeBased: '#2E5BFF',
	performance: '#7B9CFF',
	unvested: '#D1D5DB',
} as const;

export const TotalVestingAllocationStyles = styled.div`
	.legend {
		padding: 0 0.25rem;
	}
`;
